import { ReactNode } from 'react';
import { Link } from 'react-router';
import { foundationMotionTokens, foundationRadiusTokens, foundationSemantic, foundationSpacingTokens } from '../../foundation';
import { cx } from './utils';

interface SidebarNavItemProps {
  to: string;
  icon: ReactNode;
  label: string;
  isActive?: boolean;
  collapsed?: boolean;
  onClick?: () => void;
}

export default function SidebarNavItem({
  to,
  icon,
  label,
  isActive = false,
  collapsed = false,
  onClick
}: SidebarNavItemProps) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={cx(
        `flex items-center ${foundationSpacingTokens.navItem} ${foundationRadiusTokens.lg} transition-colors duration-150`,
        isActive
          ? foundationSemantic.nav.itemActive
          : `${foundationSemantic.nav.itemBase}`
      )}
    >
      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {icon}
        </svg>
      </div>
      <span
        className={cx(
          `ml-3 text-sm font-medium whitespace-nowrap ${foundationMotionTokens.opacityFast}`,
          collapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100'
        )}
      >
        {label}
      </span>
    </Link>
  );
}

export type { SidebarNavItemProps };
